
import React from 'react';

const DelayedTasks = ({ tasks }) => {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md h-full flex flex-col">
            <h3 className="text-sm font-bold text-gray-900 mb-4 shrink-0">Top Delays & Causes</h3>
            <div className="flex flex-col gap-3 overflow-y-auto pr-1 min-h-[100px] max-h-[400px] flex-1">
                {tasks?.length > 0 ? (
                    tasks.map((task) => (
                        <div key={task.id} className="bg-[#F9FAFB] p-3 rounded-lg border-l-4" style={{ borderColor: task.color || '#FF7676' }}>
                            <div className="flex items-start justify-between gap-2 mb-1">
                                <h4 className="text-sm font-bold text-gray-900 flex-1">{task.title}</h4>
                                {task.workType && (
                                    <span className="text-[10px] uppercase font-semibold px-2 py-0.5 rounded bg-blue-100 text-blue-700 whitespace-nowrap">
                                        {task.workType}
                                    </span>
                                )}
                            </div>
                            <p className="text-xs text-gray-600 mb-2">{task.cause}</p>
                            <div className="flex justify-between items-center mt-2">
                                <p className="text-[11px] font-bold text-gray-900">{task.person}</p>
                                <span className="text-[10px] uppercase font-semibold px-2 py-0.5 rounded bg-gray-200 text-gray-700">
                                    {task.status}
                                </span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="h-full flex flex-col items-center justify-center text-center px-4 py-8">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-green-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Delays Reported
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Great news! No delays have been reported for this week. Keep up the excellent work!
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DelayedTasks;
